import React from "react";
import PropTypes from "prop-types";
import L from "leaflet";

import "./LeafletMap.css";

export default class LeafletMap extends React.Component {
  state = {
    centerLocation: {
      lat: 37.86985,
      lng: -122.259616
    },
    zoom: 16
  };

  componentDidMount() {
    // center on first marker
    if (this.props.markers && this.props.markers.length > 0) {
      const { lat, lng } = this.props.markers[0];
      this.setState({
        centerLocation: { lat, lng }
      });
    }

    // create map
    const { lat, lng } = this.state.centerLocation;
    this.map = L.map("map", {
      center: [lat, lng],
      zoom: this.state.zoom,
      layers: [
        L.tileLayer("http://{s}.tile.osm.org/{z}/{x}/{y}.png", {
          attribution:
            '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        })
      ]
    });
    this.currentMarkers = L.layerGroup().addTo(this.map);
    this.loadMarkers();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.markers !== this.props.markers) {
      this.loadMarkers();
    }
  }

  loadMarkers = () => {
    if (!this.props.markers) {
      console.log("no markers provided");
      return;
    }

    // remove all previous markers
    this.currentMarkers.clearLayers();

    // create new markers
    this.props.markers.forEach((marker, index) => {
      const currMarker = L.marker([marker.lat, marker.lng], {
        icon: new L.divIcon({
          html: `<div class="numberPinOnMap">
                      <div class="number">${index}</div>
                    </div>`,
          className: ""
        })
      })
        .addTo(this.map)
        .bindPopup(`${index} - ${marker.name}`)
        .addTo(this.currentMarkers)
        .on("click", this.handleMarkerClick);

      // save id
      currMarker._icon.id = `marker_${index}`;

      if (index === this.props.focusOnMarker) {
        currMarker.fire("click");
        this.handleMarkerClick({ latlng: [marker.lat, marker.lng] });
      }
    });
  };

  handleMarkerClick = event => {
    this.setState({ centerLocation: event.latlng });
    if (event.latlng) this.map.flyTo(event.latlng, this.state.zoom);

    // scroll listing into view
    // TODO: fix for IE?
    // const el = event.srcElement || event.target;
    const clickedID = event.target && event.target._icon.id;
    if (clickedID) {
      const idNumber = clickedID.substring(clickedID.indexOf("_") + 1);
      document.getElementById(`address_${idNumber}`).scrollIntoView();
    }
  };

  render() {
    return (
      <div style={{ width: "100%", ...this.props.containerStyle }}>
        <div id="map" />
      </div>
    );
  }
}

LeafletMap.propTypes = {
  markers: PropTypes.array,
  focusOnMarker: PropTypes.number,
  containerStyle: PropTypes.object
};
